import {
  createApiRef,
  createComponentExtension,
  createPlugin,
} from '@mainstage/core-plugin-api';

import { rootRouteRef } from './routes';
import {
  AccessTokenApi,
  ServiceAccountsApi,
} from '@agilelab/plugin-wb-service-accounts-common';

export const wbServiceAccountsPlugin = createPlugin({
  id: 'wb-service-accounts',
  routes: {
    root: rootRouteRef,
  },
});

/** @public */
export const AccessTokenCard: () => JSX.Element =
  wbServiceAccountsPlugin.provide(
    createComponentExtension({
      name: 'AccessTokenCard',
      component: {
        lazy: () =>
          import('./components/AccessTokenCard').then(m => m.AccessTokenCard),
      },
    }),
  );

/** @public */
export const GitTokensCard: () => JSX.Element = wbServiceAccountsPlugin.provide(
  createComponentExtension({
    name: 'GitTokensCard',
    component: {
      lazy: () =>
        import('./components/GitTokensCard').then(m => m.GitTokensCard),
    },
  }),
);

/**
 * The API reference for the ServiceAccountsApi.
 * @public
 */
export const serviceAccountsApiRef = createApiRef<ServiceAccountsApi>({
  id: 'plugin.service-accounts',
});

/**
 * The API reference for the AccessTokenApi.
 * @public
 */
export const accessTokenApiRef = createApiRef<AccessTokenApi>({
  id: 'plugin.access-token',
});
